module.exports = __webpack_public_path__ + "img/app-hjsq.2a3b7084.png";